/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React from 'react';
import { Link } from 'react-router-dom';
// Redux Toolkit
import { useSelector } from 'react-redux';
import { selectUser } from '../../store/userSlice';
import authRoles from '../../auth/authRoles';
// BASE components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
import useThemeMediaQuery from '../../../@BASE/hooks/useThemeMediaQuery';
// Material-UI components
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
// Custom components
import EmptyVersionsCard from '../crud/instance/version/EmptyVersionsCard';

function ExportCard() {
  const user = useSelector(selectUser);

  return (
    <div className="w-full">
      <div className="mb-32 space-y-16">
        <Typography className="grow text-2xl font-bold tracking-tight leading-none py-8">
          Export
        </Typography>
        <Divider />
        <Paper className="flex flex-col flex-auto p-24 shadow rounded-xl overflow-hidden">
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <Typography className="text-lg font-medium tracking-tight leading-6 truncate">
                Download
              </Typography>
              <Typography
                className="text-md font-medium"
                color="text.secondary"
              >
                Lesson Data
              </Typography>
            </div>
          </div>
          {authRoles.leadEditor.includes(user.role) && (
            <div className="flex justify-end">
              <Button
                to="export"
                component={Link}
                variant="outlined"
                endIcon={
                  <BASESvgIcon className="" size={20}>
                    heroicons-solid:download
                  </BASESvgIcon>
                }
              >
                Export
              </Button>
            </div>
          )}
        </Paper>
      </div>
    </div>
  );
}

export default ExportCard;
